/**
 * Engine API
 * Civilization Engine API
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CityInfoDto } from './cityInfoDto';
import { LinkDto } from './linkDto';
import { MapGeometryDto } from './mapGeometryDto';

export interface MapDto { 
    firstTileUuid?: string;
    firstTileDirection?: MapDto.FirstTileDirectionEnum;
    tilesUuidOrder?: Array<string>;
    civTileNames?: Array<string>;
    links?: Array<LinkDto>;
    tilesVisibilityByUuid?: { [key: string]: boolean; };
    citiesInfoByUuid?: { [key: string]: CityInfoDto; };
    geometry?: MapGeometryDto;
}
export namespace MapDto {
    export type FirstTileDirectionEnum = 'Up' | 'Right' | 'Down' | 'Left';
    export const FirstTileDirectionEnum = {
        Up: 'Up' as FirstTileDirectionEnum,
        Right: 'Right' as FirstTileDirectionEnum,
        Down: 'Down' as FirstTileDirectionEnum,
        Left: 'Left' as FirstTileDirectionEnum
    };
}